import { Link } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const LinkIcon = createLucideIcon(Link);
